import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { addParam } from '../../../../api/helper';
import {
  ROUTE_CLIENT_USER_VIEW
} from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { ACL } from '../../../../config/constants/UogACL/ACL';
import { hideNotification } from '../../../../store/actions/notification';

function ViewUser(props) {
  if (! ACL.CLIENT.USERS.VIEW.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`view-icon-` + props.order.user.id}
        onClick={e => {
          e.preventDefault();
          store.dispatch(hideNotification());
          history.push(
            addParam(ROUTE_CLIENT_USER_VIEW, { ':userId': props.order.user.id }),
            {prevLocation: history.location}
          );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="cursor-pointer"
          pointerEvents="none"
          icon={faUser}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${props.order.user.id}`}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage id="messages.view-user" />
      </UncontrolledTooltip>
    </Fragment>
  )
}

export { ViewUser };
